// IMPORTANT: Any updates to ROLES object must be mirrored in ROLES object
// located in ../api/config/roles.js
const ROLES = {
	user: 'user',
	admin: 'admin',
	developer: 'developer',
};

module.exports.ROLES = ROLES;
